import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ChevronUp, Globe, Share2, MessageCircle } from 'lucide-react';

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div style={{ background: '#F5F5F5', padding: '0 24px 40px' }}>
      <div style={{
        background: '#1B2A4A',
        borderRadius: '20px',
        padding: '60px 60px 0',
        position: 'relative',
      }}>

        {/* Scroll to top */}
        <button onClick={scrollToTop} aria-label="Scroll to top" style={{
          position: 'absolute', top: '40px', right: '40px',
          background: '#00A878', border: 'none',
          borderRadius: '50%', width: '48px', height: '48px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', boxShadow: '0 4px 16px rgba(0,168,120,0.4)',
        }}>
          <ChevronUp size={22} color="#fff" />
        </button>

        {/* Columns */}
        <div className="row g-5 pb-5">

          {/* Brand */}
          <div className="col-lg-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <MapPin size={22} color="#00A878" />
              <span style={{ color: '#fff', fontWeight: '900', fontSize: '1.4rem', fontStyle: 'italic' }}>
                Spot Finder
              </span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem', lineHeight: 1.8, maxWidth: '280px' }}>
              Find available parking across Nairobi in real time. Reserve your spot, pay via M-Pesa, and park stress-free.
            </p>
          </div>

          {/* Links */}
          <div className="col-lg-2">
            <h6 style={{ color: '#fff', fontWeight: '800', marginBottom: '20px', fontSize: '1rem' }}>Spot Finder</h6>
            <ul className="list-unstyled">
              {[['/', 'Find a Spot'], ['/about', 'About Us'], ['#', 'Get the App'], ['/blog', 'Blog']].map(([path, label]) => (
                <li key={label} style={{ marginBottom: '12px' }}>
                  <Link to={path} style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#00A878'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-lg-2">
            <h6 style={{ color: '#fff', fontWeight: '800', marginBottom: '20px', fontSize: '1rem' }}>Services</h6>
            <ul className="list-unstyled">
              {['Reserve a Bay', 'Monthly Parking', 'Corporate Parking', 'List Your Lot'].map(label => (
                <li key={label} style={{ marginBottom: '12px' }}>
                  <a href="#" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.9rem' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#00A878'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-lg-4">
            <h6 style={{ color: '#fff', fontWeight: '800', marginBottom: '20px', fontSize: '1rem' }}>Contact Us</h6>
            <ul className="list-unstyled">
              <li className="d-flex align-items-center gap-3 mb-3">
                <Phone size={16} color="#00A878" />
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' }}>+254 700 000 000</span>
              </li>
              <li className="d-flex align-items-center gap-3 mb-3">
                <Mail size={16} color="#00A878" />
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' }}>hello@spotfinder.co.ke</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <MapPin size={16} color="#00A878" />
                <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' }}>Westlands, Nairobi, Kenya</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '12px',
          margin: '0 -60px',
          padding: '20px 60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
        }}>

          {/* Left — copyright */}
          <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem' }}>
            Copyright &copy;2026 Spot Finder. All rights reserved.
          </span>

          {/* Center — legal links */}
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <Link
              to="/terms"
              style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = '#00A878'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.35)'}
            >
              Terms & Conditions
            </Link>
            <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.8rem' }}>·</span>
            <Link
              to="/privacy"
              style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = '#00A878'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.35)'}
            >
              Privacy Policy
            </Link>
          </div>

          {/* Right — social icons */}
          <div className="d-flex gap-3">
            {[
              { icon: <Globe size={16} />, href: '#', label: 'Website' },
              { icon: <Share2 size={16} />, href: '#', label: 'Share' },
              { icon: <MessageCircle size={16} />, href: '#', label: 'Chat' },
            ].map(({ icon, href, label }, i) => (
              <a key={i} href={href} aria-label={label} style={{
                width: '36px', height: '36px', borderRadius: '50%',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'rgba(255,255,255,0.5)', textDecoration: 'none',
              }}
                onMouseEnter={e => { e.currentTarget.style.background = '#00A878'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}>
                {icon}
              </a>
            ))}
          </div>

        </div>

      </div>
    </div>
  );
}

export default Footer;